var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Prop, Watch, ModelSync } from 'vue-property-decorator';
import { BRow, BCol, BCard, BOverlay } from 'bootstrap-vue';
import debounce from 'lodash/debounce';
import axios from 'axios';
import MountKitDesignOption from 'components/materials/MountKitDesignOption.vue';
let MountKitDesignSelector = class MountKitDesignSelector extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.debouncedUpdate = debounce(this.update, 350);
        this.equalSizes = [];
        this.unequalSizes = [];
    }
    get fromPrice() {
        return this.sizeType == 'artwork' ? null : this.minPrice;
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            if (this.sizeType == 'artwork') {
                // Get frame sizes
                let { data: sizes } = yield axios
                    .get('/api/materials/mountKits/frameSizes', {
                    params: {
                        length: this.size.length,
                        width: this.size.width
                    }
                });
                if (!sizes.proportional)
                    sizes.proportional = [];
                if (!sizes.unequal)
                    sizes.unequal = [];
                this.equalSizes = sizes.proportional.map(size => ({
                    width: size.size.width,
                    length: size.size.length,
                    name: size.name,
                    type: size.type,
                    price: size.price || '0.00'
                }));
                this.unequalSizes = sizes.unequal.map(size => ({
                    width: size.size.width,
                    length: size.size.length,
                    name: size.name,
                    type: size.type,
                    price: size.price || '0.00'
                }));
                this.selectSize(this.equalSizes.length > 0
                    ? this.equalSizes[0]
                    : this.unequalSizes[0]);
            }
            else {
                // Get item sizes
                let { data: sizes } = yield axios
                    .get('/api/materials/mountKits/itemSizes', {
                    params: {
                        length: this.size.length,
                        width: this.size.width
                    }
                });
                if (!sizes.proportional)
                    sizes.proportional = [];
                if (!sizes.unequal)
                    sizes.unequal = [];
                this.equalSizes = sizes.proportional.map(size => ({
                    width: size.size.width,
                    length: size.size.length,
                    name: size.name,
                    type: size.type
                }));
                this.unequalSizes = sizes.unequal.map(size => ({
                    width: size.size.width,
                    length: size.size.length,
                    name: size.name,
                    type: size.type
                }));
                this.selectSize(this.equalSizes.length > 0
                    ? this.equalSizes[0]
                    : this.unequalSizes[0]);
            }
            this.loading = false;
        });
    }
    selectSize(size) {
        this.$emit('change', size);
    }
};
__decorate([
    ModelSync('otherSize', 'change', { type: Object })
], MountKitDesignSelector.prototype, "selectedOtherSize", void 0);
__decorate([
    Prop(Object)
], MountKitDesignSelector.prototype, "size", void 0);
__decorate([
    Prop(String)
], MountKitDesignSelector.prototype, "sizeType", void 0);
__decorate([
    Prop(String)
], MountKitDesignSelector.prototype, "boardCode", void 0);
__decorate([
    Prop({ type: String, required: false })
], MountKitDesignSelector.prototype, "minPrice", void 0);
__decorate([
    Watch('size', { deep: true })
], MountKitDesignSelector.prototype, "debouncedUpdate", void 0);
MountKitDesignSelector = __decorate([
    Component({
        components: {
            BRow, BCol, BCard, BOverlay,
            MountKitDesignOption
        }
    })
], MountKitDesignSelector);
export default MountKitDesignSelector;
